import api from '../../plugins/api';

// Ð¡Ð¼ÐµÐ½Ð° Ð½Ð¾Ð¼ÐµÑÐ° Ð²Ð»Ð°Ð´ÐµÐ»ÑÑÐ° â Ð´Ð¾ÑÑÑÐ¿Ð½Ð° Ð´Ð¾ Ð½Ð°ÑÐ°Ð»Ð° Ð¿ÑÐ¾Ð²ÐµÑÐºÐ¸ Ð±Ð°Ð½ÐºÐ¾Ð¼ (Ð¿.4.2 ÑÑÐµÐ¼Ñ).
const ffinUpdateOwnerPhone = ({ appealId, mobilePhone }) => {
  return api.patch('/api/bank/ffin/owner', { appealId, mobilePhone });
};

export default ffinUpdateOwnerPhone;
